/**
 * @author Liang Huang
 * @module 路由配置
 * @date   2019-3-22
 */
import React, { Suspense } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { Page404, SkeletonPage } from '@ywk/mobile-components';
const routeConfig = require(`./${process.env.REACT_APP_PLATFORM}_conf.tsx`);

interface Config {
  isExact: boolean;
  path: string;
  routes: Config[];
  component: ({ children }: any) => JSX.Element;
}
class Router extends React.Component {
  renderRoute(subConfig: Config) {
    const { isExact, path, routes, component: AComponent } = subConfig;

    let SubComponent = AComponent;

    if (routes) {
      SubComponent = () => (
        <AComponent>
          <Suspense fallback={<SkeletonPage hasHeader={true} />}>
            <Switch>
              {routes.map((item: any, index: number) => {
                if (item.routes) {
                  return this.renderRoute(item);
                } else {
                  return <Route key={index} exact={!!item.isExact} path={item.path} component={item.component} />;
                }
              })}
              <Route component={Page404} />
            </Switch>
          </Suspense>
        </AComponent>
      );
    }

    return <Route key={path} exact={!!isExact} path={path} component={SubComponent} />;
  }

  render() {
    return <BrowserRouter>{this.renderRoute(routeConfig.default)}</BrowserRouter>;
  }
}

export default Router;
